import React from 'react'
import Icon from '@mdi/react'
import { mdiTune } from '@mdi/js'
import { t } from '../i18n'
import {
  getPresetsForModality,
  RESET_WW_PRESET,
} from './WWPresetManager'
import '../skins/wwwc-presets.css'

/**
 * Panel flotante de presets WW/WC (mismo look que joystick).
 */
function WWPresetPanel({
  modality = null,
  presets: presetsProp = null,
  skin = 'classic',
  style,
  className = '',
  onSelect,
  onPointerDown,
  onClick,
}) {
  const presets = presetsProp || [
    ...getPresetsForModality(modality),
    RESET_WW_PRESET,
  ]
  const skinKey =
    skin === 'studio' || skin === 'edge' ? skin : 'classic'

  return (
    <div
      className={`udv-wwwc-presets udv-wwwc-presets--${skinKey} ${className}`.trim()}
      style={style}
      role="menu"
      aria-label={t('joystick.presetsTitle')}
      onPointerDown={onPointerDown}
      onClick={onClick}
    >
      <div className="udv-wwwc-presets-title">
        <Icon path={mdiTune} size={0.7} color="currentColor" />
        <span>
          {t('joystick.presetsTitle')}
          {modality ? ` · ${modality}` : ''}
        </span>
      </div>
      <div className="udv-wwwc-presets-list">
        {presets.map((preset) => (
          <button
            key={preset.name}
            type="button"
            className="udv-wwwc-preset-item"
            onClick={() => onSelect && onSelect(preset)}
          >
            <span className="udv-wwwc-preset-name">
              {preset.name === 'Reset'
                ? t('joystick.presetReset')
                : preset.name}
            </span>
            {preset.ww != null && preset.wc != null ? (
              <span className="udv-wwwc-preset-meta">
                WW {preset.ww} · WC {preset.wc}
              </span>
            ) : null}
          </button>
        ))}
      </div>
    </div>
  )
}

/** Posición relativa al borde derecho del anchor (joystick / edge drawer). */
export function wwwcPresetStyleRightOf(anchorEl) {
  if (!anchorEl || typeof anchorEl.getBoundingClientRect !== 'function') {
    return { left: 0, top: 0 }
  }
  const rect = anchorEl.getBoundingClientRect()
  return {
    left: rect.right,
    top: rect.top + rect.height / 2,
    transform: 'translate(12px, -50%)',
  }
}

/** Posición a la izquierda del anchor (ghost rail derecha). */
export function wwwcPresetStyleLeftOf(anchorEl) {
  if (!anchorEl || typeof anchorEl.getBoundingClientRect !== 'function') {
    return { left: 0, top: 0 }
  }
  const rect = anchorEl.getBoundingClientRect()
  return {
    left: rect.left,
    top: rect.top + rect.height / 2,
    transform: 'translate(calc(-100% - 12px), -50%)',
  }
}

export default WWPresetPanel
